import { render, staticRenderFns } from "./PaymentChart.vue?vue&type=template&id=0d38f2a0"
import script from "./PaymentChart.vue?vue&type=script&lang=js"
export * from "./PaymentChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports